import { Controller } from "@hotwired/stimulus";
import { Target, TypedController, Value } from "@vytant/stimulus-decorators";
import {
  JSONEditorPropsOptional,
  JsonEditor,
  RenderValueProps,
  RenderValueComponentDescription,
  renderValue,
  createJSONEditor,
} from "vanilla-jsoneditor";

@TypedController
export default class extends Controller {
  @Value(String) readonly jsonValue: string;
  @Value(Boolean) readonly readOnlyValue: boolean;

  @Target readonly inputTarget: HTMLInputElement;
  private declare readonly hasInputTarget: boolean;

  private editor: JsonEditor | null = null;

  connect() {
    const editorProps: JSONEditorPropsOptional = {
      content: { json: this.getJson(), text: undefined },
      readOnly: this.readOnlyValue,
      navigationBar: false,
      onRenderValue: this.handleRenderValue,
      ...(!this.readOnlyValue && {
        onChange: this.handleChange.bind(this),
      }),
    };

    this.editor = createJSONEditor({
      target: this.element,
      props: editorProps,
    });
  }

  disconnect() {
    if (this.editor) {
      void this.editor.destroy();
    }
  }

  handleChange(updatedContent: { json: JSON; text: undefined }) {
    if (this.hasInputTarget) {
      const contentToSave = updatedContent.json || updatedContent;
      this.inputTarget.value = JSON.stringify(contentToSave);
    }
  }

  private getJson() {
    try {
      return JSON.parse(this.jsonValue);
    } catch (e) {
      return {};
    }
  }

  private handleRenderValue(props: RenderValueProps): RenderValueComponentDescription[] {
    if (props.value === "") {
      props.value = '""';
    }

    return renderValue(props);
  }
}
